import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { IDarkTheme } from "styles/darkTheme";

const styles = makeStyles((theme: IDarkTheme) =>
  createStyles({
    statTitle: {
      fontSize: theme.fontSize.heading_5,
      fontWeigth: theme.fontWeight.big,
      color: theme.colors.neutrals.neturals_100
    },
    statDescription: {
      fontWeight: theme.fontWeight.normal,
      fontSize: theme.fontSize.bodyText_1,
      color: theme.colors.neutrals.neutrals_80,
      maxWidth: "400px"
    }
  })
);

export default styles;
